import React from "react";
import HeroSection from "../components/landing/hero/HeroSection"
import OneEcosystem from "../components/landing/feature/OneEcosystem";
import FeaturesGrid from "../components/landing/feature/FeaturesGrid";
import EmpoweringSMMEs from "../components/landing/headline/EmpoweringSMMEs"
import BankingIntegration from "../components/landing/headline/BankingIntegration"
import SectionModules from "../components/landing/module/SectionModules"
import PeekUnderHood from "../components/landing/getintouch/PeekUnderHood"
import startAnywhere from "../assets/start_anywhere.png"
import unifiedBilling from "../assets/unified_billing.png"
import nativeSynergy from "../assets/native_synergy.png"
import totalVisibility from "../assets/total_visibility.png"

export default function Home() {
  const features = [
    {
      image: startAnywhere,
      altText: "Start Anywhere",
      title: "Start Anywhere",
      description: "Start exactly where you are today. Scale up your modules as your business grows."
    },
    {
      image: unifiedBilling,
      altText: "Unified Billing",
      title: "Unified Billing",
      description: "Simplify your overhead with one account and a single, transparent bill for all services."
    },
    {
      image: nativeSynergy,
      altText: "Native Synergy",
      title: "Native Synergy",
      description: "Engineered for perfect compatibility across all operations."
    },
    {
      image: totalVisibility,
      altText: "Total Visibility",
      title: "Total Visibility",
      description: "Access all your data from one master login."
    }
  ];

  return (
    <>
      <HeroSection />
      <OneEcosystem />
      <FeaturesGrid features={features} />
      <EmpoweringSMMEs />
      <BankingIntegration />
      <SectionModules />
      <PeekUnderHood />
    </>
  );
}
